import { isEntry } from './isEntry';
import type { GetContentType } from '~/types/GetContentType';
import type { IContentPage } from '~/lib/ContentfulService';

export const contentPageContentIds = [
  'contentPage'
] satisfies GetContentType<IContentPage>[];

export function isContentPage(value: unknown): value is IContentPage {
  return (
    isEntry(value) &&
    (value.sys?.contentType?.sys?.id as GetContentType<IContentPage>) ===
      'contentPage'
  );
}

export function isContentPageType(
  value?: string
): value is GetContentType<IContentPage> {
  return value === 'contentPage';
}
